webpackJsonp([47484376470386],{

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keys = [['C', 'OPER.DIV', 'OPER.STAR', 'OPER.MINUS'], ['DIGIT.7', 'DIGIT.8', 'DIGIT.9', 'OPER.PLUS'], ['DIGIT.4', 'DIGIT.5', 'DIGIT.6', 'EQUALS'], ['DIGIT.1', 'DIGIT.2', 'DIGIT.3', 'POINT'], ['DIGIT.0']];
	
	var labels = {
	  C: 'C',
	  'OPER.DIV': '/',
	  'OPER.STAR': '*',
	  'OPER.MINUS': '-',
	  'OPER.PLUS': '+',
	  EQUALS: '=',
	  POINT: '.'
	};
	
	var keyLabel = function keyLabel(event) {
	  return labels[event] || event.replace('DIGIT.', '');
	};
	
	var CalculatorPanel = function CalculatorPanel(_ref) {
	  var sc = _ref.sc,
	      datamodel = _ref.datamodel;
	
	  var shortExpr = datamodel && datamodel.short_expr;
	  var res = datamodel && typeof datamodel.res !== 'undefined' ? datamodel.res : 0;
	  var longExpr = datamodel && datamodel.long_expr ? datamodel.long_expr : '';
	  var display = shortExpr === '' || typeof shortExpr === 'undefined' ? res : shortExpr;
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f6f6f6' } },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          minHeight: '4rem',
	          marginBottom: '0.75rem',
	          padding: '0.75rem',
	          background: '#202124',
	          color: '#f2f2f2',
	          textAlign: 'right',
	          fontFamily: 'monospace'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { minHeight: '1rem', color: '#9aa0a6', fontSize: '0.875rem', overflow: 'hidden' } },
	        longExpr || '\xA0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: '2rem', lineHeight: '2.25rem', wordBreak: 'break-all' } },
	        display
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      keys.map(function (row, rowIndex) {
	        return _react2.default.createElement(
	          'div',
	          { key: rowIndex, style: { display: 'flex' } },
	          row.map(function (event) {
	            return _react2.default.createElement(
	              'button',
	              {
	                key: event,
	                className: event === 'EQUALS' ? 'btn btn-success' : event.indexOf('OPER.') === 0 ? 'btn btn-info' : 'btn btn-secondary',
	                style: {
	                  flex: event === 'DIGIT.0' ? '0 0 calc(50% - 0.5rem)' : '1 1 0',
	                  margin: '0.25rem',
	                  height: '3rem',
	                  fontSize: '1.1rem'
	                },
	                onClick: function onClick() {
	                  return sc && sc.gen(event);
	                }
	              },
	              keyLabel(event)
	            );
	          })
	        );
	      })
	    )
	  );
	};
	
	exports.default = CalculatorPanel;
	module.exports = exports['default'];

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       initial=\"wrapper\"\n       name=\"CalculatorStateMachine\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data id=\"long_expr\"/>\n    <data id=\"short_expr\"/>\n    <data id=\"res\"/>\n  </datamodel>\n\n  <state id=\"wrapper\" initial=\"on\">\n    <transition event=\"CALC.DO\" type=\"internal\">\n      <assign location=\"short_expr\" expr=\"''+ res\"/>\n      <assign location=\"long_expr\" expr=\"''\"/>\n      <assign location=\"res\" expr=\"0\"/>\n    </transition>\n\n    <transition event=\"CALC.SUB\" type=\"internal\">\n      <if cond=\"short_expr!=''\">\n        <assign location=\"long_expr\" expr=\"long_expr+'('+short_expr+')'\"/>\n      </if>\n      <assign location=\"res\" expr=\"eval(long_expr)\"/>\n      <assign location=\"short_expr\" expr=\"''\"/>\n      <send event=\"DISPLAY.UPDATE\"/>\n    </transition>\n\n    <transition event=\"DISPLAY.UPDATE\" type=\"internal\">\n      <log label=\"'result'\" expr=\"short_expr==''?res:short_expr\"/>\n      <send event=\"updateDisplay\">\n        <param name=\"display\" expr=\"short_expr==''?res:short_expr\"/>\n      </send>\n    </transition>\n\n    <transition event=\"OP.INSERT\" type=\"internal\">\n      <log expr=\"_event.data.operator\"/>\n      <if cond=\"_event.data.operator == 'OPER.PLUS'\">\n        <assign location=\"long_expr\" expr=\"long_expr+'+'\"/>\n        <elseif cond=\"_event.data.operator=='OPER.MINUS'\"/>\n        <assign location=\"long_expr\" expr=\"long_expr+'-'\"/>\n        <elseif cond=\"_event.data.operator=='OPER.STAR'\"/>\n        <assign location=\"long_expr\" expr=\"long_expr+'*'\"/>\n        <elseif cond=\"_event.data.operator=='OPER.DIV'\"/>\n        <assign location=\"long_expr\" expr=\"long_expr+'/'\"/>\n      </if>\n    </transition>\n\n    <state id=\"on\" initial=\"ready\">\n      <onentry>\n        <send event=\"DISPLAY.UPDATE\"/>\n      </onentry>\n      <transition event=\"C\" target=\"on\" type=\"internal\"/>\n\n      <state id=\"operand1\">\n        <transition event=\"OPER\" target=\"opEntered\"/>\n        <state id=\"int1\">\n          <onentry>\n            <assign expr=\"short_expr+_event.name.substr(_event.name.lastIndexOf('.')+1)\" location=\"short_expr\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </onentry>\n          <transition event=\"POINT\" target=\"frac1\"/>\n          <transition event=\"DIGIT\" type=\"internal\">\n            <assign location=\"short_expr\" expr=\"short_expr+_event.name.substr(_event.name.lastIndexOf('.')+1)\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </transition>\n        </state>\n        <state id=\"frac1\">\n          <onentry>\n            <assign expr=\"short_expr+'.'\" location=\"short_expr\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </onentry>\n          <transition event=\"DIGIT\" type=\"internal\">\n            <assign location=\"short_expr\" expr=\"short_expr+_event.name.substr(_event.name.lastIndexOf('.')+1)\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </transition>\n        </state>\n        <state id=\"zero1\">\n          <transition cond=\"_event.name != 'DIGIT.0'\" event=\"DIGIT\" target=\"int1\"/>\n          <transition event=\"POINT\" target=\"frac1\"/>\n        </state>\n      </state>\n\n      <state id=\"ready\" initial=\"begin\">\n        <transition event=\"OPER\" target=\"opEntered\"/>\n        <transition event=\"DIGIT.0\" target=\"zero1\">\n          <assign location=\"short_expr\" expr=\"''\"/>\n        </transition>\n        <transition event=\"DIGIT\" target=\"int1\">\n          <assign location=\"short_expr\" expr=\"''\"/>\n        </transition>\n        <transition event=\"POINT\" target=\"frac1\">\n          <assign location=\"short_expr\" expr=\"''\"/>\n        </transition>\n        <state id=\"begin\">\n          <onentry>\n            <assign expr=\"''\" location=\"long_expr\"/>\n            <assign expr=\"0\" location=\"short_expr\"/>\n            <assign expr=\"0\" location=\"res\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </onentry>\n          <transition event=\"OPER.MINUS\" target=\"negated1\"/>\n        </state>\n        <state id=\"result\"/>\n      </state>\n\n      <state id=\"negated1\">\n        <onentry>\n          <assign expr=\"'-'\" location=\"short_expr\"/>\n          <send event=\"DISPLAY.UPDATE\"/>\n        </onentry>\n        <transition event=\"DIGIT.0\" target=\"zero1\"/>\n        <transition event=\"DIGIT\" target=\"int1\"/>\n        <transition event=\"POINT\" target=\"frac1\"/>\n      </state>\n\n      <state id=\"operand2\">\n        <transition event=\"OPER\" target=\"opEntered\">\n          <raise event=\"CALC.SUB\"/>\n          <raise event=\"OP.INSERT\"/>\n        </transition>\n        <transition event=\"EQUALS\" target=\"result\">\n          <raise event=\"CALC.SUB\"/>\n          <raise event=\"CALC.DO\"/>\n        </transition>\n        <state id=\"int2\">\n          <onentry>\n            <assign expr=\"short_expr+_event.name.substr(_event.name.lastIndexOf('.')+1)\" location=\"short_expr\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </onentry>\n          <transition event=\"DIGIT\" type=\"internal\">\n            <assign location=\"short_expr\" expr=\"short_expr+_event.name.substr(_event.name.lastIndexOf('.')+1)\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </transition>\n          <transition event=\"POINT\" target=\"frac2\"/>\n        </state>\n        <state id=\"frac2\">\n          <onentry>\n            <assign expr=\"short_expr +'.'\" location=\"short_expr\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </onentry>\n          <transition event=\"DIGIT\" type=\"internal\">\n            <assign location=\"short_expr\" expr=\"short_expr +_event.name.substr(_event.name.lastIndexOf('.')+1)\"/>\n            <send event=\"DISPLAY.UPDATE\"/>\n          </transition>\n        </state>\n        <state id=\"zero2\">\n          <transition cond=\"_event.name != 'DIGIT.0'\" event=\"DIGIT\" target=\"int2\"/>\n          <transition event=\"POINT\" target=\"frac2\"/>\n        </state>\n      </state>\n\n      <state id=\"opEntered\">\n        <onentry>\n          <raise event=\"CALC.SUB\"/>\n          <send event=\"OP.INSERT\" target=\"#_internal\">\n            <param expr=\"_event.name\" name=\"operator\"/>\n          </send>\n        </onentry>\n        <transition event=\"OPER.MINUS\" target=\"negated2\"/>\n        <transition event=\"POINT\" target=\"frac2\"/>\n        <transition event=\"DIGIT.0\" target=\"zero2\"/>\n        <transition event=\"DIGIT\" target=\"int2\"/>\n      </state>\n\n      <state id=\"negated2\">\n        <onentry>\n          <assign expr=\"'-'\" location=\"short_expr\"/>\n          <send event=\"DISPLAY.UPDATE\"/>\n        </onentry>\n        <transition event=\"DIGIT.0\" target=\"zero2\"/>\n        <transition event=\"DIGIT\" target=\"int2\"/>\n        <transition event=\"POINT\" target=\"frac2\"/>\n      </state>\n    </state>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.calculatorScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _common = __webpack_require__(39);
	
	var _calculatorPanel = __webpack_require__(406);
	
	var _calculatorPanel2 = _interopRequireDefault(_calculatorPanel);
	
	var _calculator = __webpack_require__(903);
	
	var _calculator2 = _interopRequireDefault(_calculator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.calculatorScxml = _calculator2.default;
	
	var W3CCalculatorExample = function (_SCComponent) {
	  _inherits(W3CCalculatorExample, _SCComponent);
	
	  function W3CCalculatorExample(props) {
	    _classCallCheck(this, W3CCalculatorExample);
	
	    return _possibleConstructorReturn(this, _SCComponent.call(this, props, _calculator2.default));
	  }
	
	  W3CCalculatorExample.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '1180px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-10', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '1180px', width: '100%', overflow: 'auto', border: '1px solid #eee' } },
	          _react2.default.createElement(
	            'div',
	            { style: { height: '1600px', width: '1320px', position: 'relative' } },
	            _react2.default.createElement(_schviz2.default, {
	              scxmlDocumentString: _calculator2.default,
	              disableAnimation: true,
	              configuration: this.state && this.state.configuration,
	              disableZoomAnimation: true,
	              transitionsEnabled: this.state && this.state.transitionsEnabled,
	              expandAllStatesByDefault: true,
	              layoutOptions: _schviz2.default.layouts.auto,
	              id: 'w3c-calculator'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-2', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '1180px', border: '1px solid #eee' } },
	          _react2.default.createElement(_calculatorPanel2.default, { sc: this.sc, datamodel: this.state && this.state.datamodel })
	        )
	      )
	    );
	  };
	
	  return W3CCalculatorExample;
	}(_common.SCComponent);
	
	exports.default = W3CCalculatorExample;

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _w3cCalculatorExample = __webpack_require__(407);
	
	var _w3cCalculatorExample2 = _interopRequireDefault(_w3cCalculatorExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Calculator = function Calculator(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports the W3C calculator example from Alex Zhornyak\'s SCXML tutorial collection. The SCXML statechart manages operand entry, operators, decimal points, negation, and result submission while the React panel sends calculator events.'
	    ),
	    React.createElement(_w3cCalculatorExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _w3cCalculatorExample.calculatorScxml
	    )
	  );
	};
	
	var WrappedCalculator = function WrappedCalculator(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Calculator, pathname: location.pathname });
	};
	
	exports.default = WrappedCalculator;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-calculator-js-58afe450dccbb7872a08.js